import React from 'react';

import { useEmailSettings, useNewsletterSubscriptions } from '../../../../hooks';
import { Spinner } from '../../../BaseUI';
import SettingsHeading from '../SettingsHeading';
import EmailSettings from './EmailSettings';
import NotificationSettings from './NotificationSettings';
import styles from './styles.module.scss';

const EmailPreferences = () => {
  const { newsletters, isLoadingNewsletterSubscriptions } = useNewsletterSubscriptions();
  const { userEmailSettings, isLoadingUserEmailSettings } = useEmailSettings();

  if (isLoadingNewsletterSubscriptions || isLoadingUserEmailSettings) return <Spinner />;

  return (
    <div>
      <SettingsHeading title="Email Preferences" />
      <div className={styles.header}>Update your email communication preferences:</div>
      <EmailSettings newsletters={newsletters} userEmailSettings={userEmailSettings} />
      <SettingsHeading title="other" />
      <NotificationSettings userEmailSettings={userEmailSettings} />
    </div>
  );
};

export default EmailPreferences;
